import { mobiClient } from '@/services/axiosConfig'
import { MobinetCityRes, MobinetDistrictRes, MobinetQuarterRes, MobinetBuildingRes, MobinetErrorRes, MobinetDistrictReq, MobinetQuarterReq, MobinetBuildingReq } from './types'

export const getCityList = async (): Promise<MobinetCityRes | undefined> => {
  try {
    const res = await mobiClient.get('mobinethbb/city')
    return res.data
  } catch (e) {
    console.error('fetch Mobinet city list failed', e)
  }
}

export const getDistrictList = async (req: MobinetDistrictReq): Promise<MobinetDistrictRes | undefined> => {
  try {
    const headers = {
      city: req.city
    }
    const res = await mobiClient.get('mobinethbb/district', { headers })
    return res.data
  } catch (e) {
    console.error('fetch Mobinet district list failed', e)
  }
}

export const getQuarterList = async (req: MobinetQuarterReq): Promise<MobinetQuarterRes | undefined> => {
  try {
    const headers = {
      city: req.cityZip,
      district: req.districtZip
    }
    const res = await mobiClient.get('mobinethbb/quarter', { headers })
    return res.data
  } catch (e) {
    console.error('fetch Mobinet quarter list failed', e)
  }
}

export const getBuildingList = async (req: MobinetBuildingReq): Promise<MobinetBuildingRes | undefined> => {
  try {
    const headers = {
      quarter: req.quarterZip
    }
    const res = await mobiClient.get('mobinethbb//locations', { headers })
    return res.data
  } catch (e) {
    console.error('fetch Mobinet building list failed', e)
  }
}
